import { render } from "./popper.vue?vue&type=template&id=ac5c87b6&scoped=true"
import script from "./popper.vue?vue&type=script&lang=js"
export * from "./popper.vue?vue&type=script&lang=js"

import "./popper.vue?vue&type=style&index=0&id=ac5c87b6&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5c87b6"]])

export default __exports__